<template>
  <section id="hospital-settings" class="case-creation" v-loading="loading">
    <div
      v-if="getSingleSetting"
      key=""
      class="case-creation__step case-creation__patient-information"
    >
      <!-- View Hospital settings -->
      <div class="vue-form">
        <div class="case-creation__card">
          <div
            class="case-creation__body"
            v-if="getSingleSetting && status == 'view'"
          >
            <div class="">
              <el-button class="edit-btn" @click="editStatus">
                <span class="edit-icon">
                  <img
                    src="@/assets/images/icons/edit-case-information.svg"
                    alt=""
                  />

                  EDIT
                </span>
              </el-button>
            </div>

            <el-row>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Auto Fax</h4>
                  <p>{{ settingsInfo.auto_fax ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Email Notification</h4>
                  <p>{{ settingsInfo.email_notifications ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Daily Statistics</h4>
                  <p>{{ settingsInfo.daily_statistics ? "Yes" : "No" }}</p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div v-if="getSingleSetting && status == 'edit'">
            <div class="case-creation__body pb-0">
              <div class="vue-form">
                <el-form :model="form">
                  <el-row :gutter="30">
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="Auto Fax"
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.auto_fax"
                            />
                            <label for="text" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.auto_fax"
                            />
                            <label for="text">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="
                        Email Notification

                          "
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.email_notifications"
                            />
                            <label for="notifications" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.email_notifications"
                            />
                            <label for="notificaions">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="
                       Daily Statistics

                          "
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.daily_statistics"
                            />
                            <label for="notifications" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.daily_statistics"
                            />
                            <label for="notificaions">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>

        <div
          class="case-creation__actions"
          v-if="getSingleSetting && status == 'edit'"
        >
          <ul class="list">
            <li>
              <el-button
                size="medium"
                type="default"
                class="btn cancel-button"
                @click="cancelSettingDetails"
                >Cancel</el-button
              >
            </li>
            <li>
              <el-button
                size="medium"
                type="success"
                class="btn save-button"
                @click="submitSettingDetails"
                >Save</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      status: "view",
      form: {
        auto_fax: false,
        email_notifications: false,
        daily_statistics: false,
      },
      settingsInfo: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters("branches", [
      "getSingleSetting",
      "getBranchValidationErrors",
    ]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
  },
  async mounted() {
    this.fetchSettings();
    this.goToSettings();
  },
  methods: {
    editStatus() {
      this.status = "edit";
    },
    async fetchSettings() {
      this.loading = true;
      let params = {
        hospital_id: this.hospital_id,
      };
      await this.$store.dispatch("branches/getHospitalSettings", params);
      this.loading = false;
      this.settingsInfo = JSON.parse(JSON.stringify(this.getSingleSetting));
      this.settingsInfo.daily_statistics =
        this.settingsInfo.daily_statistics || false;
      this.form.auto_fax = this.settingsInfo.auto_fax;
      this.form.email_notifications = this.settingsInfo.email_notifications;
      this.form.email_notifications = this.settingsInfo.email_notifications;
      this.form.daily_statistics = this.settingsInfo.daily_statistics;
    },
    async goToSettings() {
      this.status = "view";
      this.fetchSettings();
    },
    async submitSettingDetails() {
      let params = {
        hospital_id: this.hospital_id,
        params: this.form,
      };
      await this.$store.dispatch("branches/updateHospitalSettings", params);

      if (this.getSettingsAddStatus) {
        successNotification("settings Updated successfully");
        this.goToSettings();
      } else if (!this.getBranchValidationErrors) {
        errorNotification("Error while updating settings");
      }
    },

    cancelSettingDetails() {
      if (Object.keys(this.form).length === 0) {
        this.clearSettingsAndGoToSettings();
      } else {
        this.$confirm("Are you sure to cancel Update Settings?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.clearSettingsAndGoToSettings();
        });
      }
    },
    clearSettingsAndGoToSettings() {
      (this.form = {}), this.goToSettings();
    },
  },
};
</script>

<style lang="scss"></style>
